import type { GridProps, GridVariant } from "@op/puck-types";
import { cls } from "@op/utils";
import { useMemo } from "react";

function getVariantClass(variant: GridVariant) {
  switch (variant) {
    case "one-col":
      return "grid-cols-1";
    case "two-col":
      return "grid-cols-1 sm:grid-cols-2";
    case "three-col":
      return "grid-cols-1 sm:grid-cols-2 md:grid-cols-3";
    case "four-col":
      return "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4";
  }
}

const Grid = ({ variant, children }: GridProps) => {
  const variantClass = useMemo(() => getVariantClass(variant), [variant]);

  return (
    <div className={cls("w-full grid gap-2", variantClass)}>{children}</div>
  );
};

export default Grid;
